import React from 'react';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import IOfferWorkNumbers from 'api/interfaces/offers/IOfferWorkNumbers';
import BasicTableNoPagination from 'components/layout/tables/BasicTableNoPagination';
import translations from 'services/translations/translations';

/**
 * The work numbers of an ordered offer: how it was split into projects in ProBuilder's
 * Projektikiljotiini and the D365 project numbers recorded there. Read only, they come
 * from ProBuilder automatically.
 */
const OfferWorkNumbers = ({
  workNumbers,
}: {
  workNumbers: IOfferWorkNumbers;
}): JSX.Element => {
  const { t } = useTranslation([
    translations.offers,
    translations.userManagement,
  ]);

  const rows = workNumbers.pieces.map((piece) => ({
    department: piece.departmentName ?? '',
    id: piece.pieceId,
    name: piece.name,
    projectNumber:
      piece.projectNumber ??
      t(`${translations.offers}:workNumbers.Waiting for number`),
    responsible: piece.responsible
      .map(
        (person) =>
          `${person.name} (${t(
            `${translations.userManagement}:titles:${person.role}`
          )})`
      )
      .join(', '),
  }));

  const columns = [
    {
      dataField: 'projectNumber',
      text: t(`${translations.offers}:workNumbers.Project number`),
    },
    {
      dataField: 'name',
      text: t(`${translations.offers}:workNumbers.Piece`),
    },
    {
      dataField: 'department',
      text: t(`${translations.offers}:workNumbers.Department`),
    },
    {
      dataField: 'responsible',
      text: t(`${translations.offers}:workNumbers.Responsible`),
    },
  ];

  return (
    <div className="offer-work-numbers">
      <Row>
        <Col>
          <div className="header-text title-spacing">
            {t(`${translations.offers}:workNumbers.Title`).toUpperCase()}
          </div>
        </Col>
      </Row>
      <p className="offer-work-numbers-status">
        {t(`${translations.offers}:workNumbers.status.${workNumbers.status}`)}
      </p>
      {rows.length > 0 ? (
        <BasicTableNoPagination columns={columns} data={rows} keyField="id" />
      ) : null}
    </div>
  );
};

export default OfferWorkNumbers;
